import { memo } from "react";
import { Handle, Position } from "@xyflow/react";

function AgentNode({ data }: { data: any }) {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white dark:bg-default-100 border-2 border-stone-400 dark:border-default-300 w-100 h-40">
      <div className="flex">
        <div className="ml-2 w-full">
          <div className="text-lg font-light text-primary flex items-center gap-2">
            {data.emoji}
            {data.name
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char: string) => char.toUpperCase())}
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400">{data.type}</div>
          <div className="max-h-22 overflow-y-auto w-full text-foreground">
            {Object.entries(data.parameters).map(([key, value]) => (
              <div key={key} className="text-sm">
                <b>{key}</b> : {String(value)}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Handle className="w-16 !bg-primary-500" position={Position.Top} type="target" />
      <Handle className="w-16 !bg-primary-500" position={Position.Bottom} type="source" />
    </div>
  );
}

export default memo(AgentNode);
